/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React from "react";
import NumberCell from "../../tableFields/NumberCell";

export const PREPAID_DEFERRED_REVENUE_BALANCE_COLUMNS = [
  {
    Header: "Contract Name",
    accessor: "contract",
    id: "contract",
    Cell: ({ value }) => value || "--",
    minWidth: 210
  },
  {
    Header: "Contract Status",
    accessor: "contract_status",
    id: "contract_status",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Contract Rate",
    accessor: "contractRate",
    id: "contractRate",
    Cell: ({ value }) => <NumberCell value={`$${value?.toFixed(2) || 0}`} />,
    minWidth: 100
  },
  {
    Header: "Last Hours Purchased",
    accessor: "lastHoursPurchased",
    id: "lastHoursPurchased",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Hours Balance",
    accessor: "hoursBalance",
    id: "hoursBalance",
    Cell: ({ value }) =>
      Number(value)?.toFixed(2) !== "NaN" ? Number(value)?.toFixed(2) : "0.00",
    minWidth: 100
  },
  {
    Header: "Amount Balance",
    accessor: "amountBalance",
    id: "amountBalance",
    Cell: ({ value }) => <NumberCell value={`$${value.toFixed(2)}`} />,
    minWidth: 100
  }
];
